<template>
  <div v-if="doc.progress > 0" class="doc-progress">
    <div class="doc-progress__bar">
      <div
        :aria-valuenow="doc.progress"
        aria-valuemin="0"
        aria-valuemax="100"
        class="doc-progress__now"
        :style="{ '--doc-progress': doc.progress }"
      ></div>
    </div>
    <p class="doc-progress__num">{{ doc.progress }}% read</p>
  </div>
</template>

<script setup lang="ts">
import { DocView } from '@/models/doc'

defineProps<{
  doc: DocView
}>()
</script>

<style lang="scss" scoped>
.doc-progress {
  width: 184px;
  @media only screen and (max-width: $w-medium-s) {
    width: 141px;
  }
  @media only screen and (min-width: $w-tablet-b) {
    max-width: 154px;
    text-align: center;
  }
  &__bar {
    height: 6px;
    background-color: rgba($color: $c-black-2, $alpha: 0.1);
    position: relative;
    border-radius: 4px;
    overflow: hidden;
  }
  &__now {
    height: 6px;
    position: absolute;
    top: 0;
    left: 0;
    background-color: $c-blue-3;
    width: calc(1% * var(--doc-progress));
  }
  &__num {
    font-size: 14px;
    text-align: center;
    line-height: 18px;
    color: $c-black-9;
    margin-top: 8px;
  }
}

.night-mode .doc-progress {
  &__bar {
    background-color: $c-dark-5;
  }
  &__num {
    color: $c-dark-8;
  }
}
</style>
